module.exports = __webpack_public_path__ + "static/media/plus.1102afb7.svg";